// 匿名函数

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var noop = function noop(_p) {
  return undefined;
};